export class EventEmitter<T> {
  private listeners: EventEmitter.Listener<T>[] = [];

  emit(state: T): void {
    this.listeners.forEach(listener => listener(state));
  }

  off(listener: EventEmitter.Listener<T>): void {
    this.unsubscribe(listener);
  }

  on(listener: EventEmitter.Listener<T>): EventEmitter.Unsubscribe {
    return this.subscribe(listener);
  }

  once(listener: EventEmitter.Listener<T>): EventEmitter.Unsubscribe {
    const onceWrapper = (state: T) => {
      listener(state);
      this.unsubscribe(onceWrapper);
    };

    return this.subscribe(onceWrapper);
  }

  subscribe(listener: EventEmitter.Listener<T>): EventEmitter.Unsubscribe {
    this.listeners.push(listener);

    return () => this.unsubscribe(listener);
  }

  unsubscribe(listener: EventEmitter.Listener<T>): void {
    this.listeners = this.listeners.filter(l => l !== listener);
  }
}

export namespace EventEmitter {
  export type Listener<T> = (value: T) => void;

  export type Unsubscribe = () => void;
}
